import { Box, Grid, MenuItem, Switch, TextField } from "@mui/material";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import SearchIcon from "@material-ui/icons/Search";
import React, { useEffect, useState } from "react";
import { Paper, Popper } from "@material-ui/core";
import {
  exportSmartTagAnalyticsPOP,
  exportSPCReportsExcel,
  exportSPCAnalyticsExcel,
} from "../services";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import "../MachineDashboard/Analytics/MachineAnalytics.css";
import DeviceListShimmer from "../../../components/Shimmer/DeviceListShimmer/DeviceListShimmer";
import { toast } from "react-toastify";

const SPCSmartTagList = ({
  time,
  formatStartDate,
  formatEndDate,
  formatStartTime,
  formatEndTime,
  range,
  machines,
  units,
  handleSelectMachine,
  handleSelectTagUnit,
  handleSelectTag,
  tagListData,
  isShimmerdevicelist,
  isShimmerUnitlist,
  isShimmerMachineslist,
  smartTagSelectmachine,
  smartTagSelectTagUnit,
  snartTagSelectTag,
  selectPOPUnitData,
  formatStartDatePOP1,
  formatEndDatePOP1,
  formatStartTimePOP1,
  formatEndTimePOP1,
  SmartTagSelectSwitch,
  handleToggleTime,
  activeSPCClass,
  disableOtherUnits,
  interval,
  agg,
  getChartBase64,
  getAnalyticsChartsBase64,
  selectedChartType,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorEl2, setAnchorEl2] = useState(null);
  const [searchTag, setSearchTag] = useState("");

  const { activeClassConsumer } = useSelector(
    (state) => state.smartTagReportSlice
  );

  console.log(
    "selectPOPUnitData",
    snartTagSelectTag.map((e) => e.tagId)
  );

  const reportSwitchColors = ["#4A90E2", "#6A5ACD"]; // Steel Blue, Deep Purple

  const switchColors = [
    "#4A90E2",
    "#6A5ACD",
    "#C99C00",
    "#EB9E79",
    "#69927A",
    "#872B81",
    "#F06292",
    "#CD4D4A",
    "#123782",
    "#544632",
    "#94655B",
    "#0F4C81",
    "#8B0000",
    "#C60BC8",
    "#7D2264",
    "#BC2F00",
    "#556830",
    "#FCA311",
    "#021116",
    "#808080",
    "#300338",
    "#634C23",
    "#841E62",
    "#F34424",
    "#003333",
    "#020000",
    "#305355",
    "#5C3A31",
    "#D9750C",
    "#0C4562",
    "#001A30",
    "#00838F",
    "#785049",
    "#FF8800",
    "#0B7C8E",
    "#08535E",
    "#0E3504",
    "#C48200",
    "#846748",
    "#075571",
    "#9C27B0",
    "#A97E07",
    "#CE286D",
    "#8409DF",
    "#0B648D",
    "#29445A",
    "#1D733F",
    "#6E02B1",
  ];

  const param = useParams();

  const notifyError = (message) =>
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
    });

  const notifySuccess = (message) =>
    toast.success(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
    });

  useEffect(() => {
    setAnchorEl(null);
    setAnchorEl2(null);
  }, []);

  const [openMachine, setOpenMachine] = useState(false);
  const [openUnit, setOpenUnit] = useState(false);

  const handlePropagation = (event) => {
    event.stopPropagation();
  };

  const handleClick = (event) => {
    setOpenMachine((prev) => !prev);
    setAnchorEl(event.currentTarget);
  };

  const handleOutsideClick = (event) => {
    if (anchorEl && !anchorEl.contains(event.target)) {
      setOpenMachine(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [anchorEl]);

  const handleClickUnit = (event) => {
    setOpenUnit((prev) => !prev);
    setAnchorEl2(event.currentTarget);
  };

  const handleOutsideClickUnit = (event) => {
    if (anchorEl2 && !anchorEl2.contains(event.target)) {
      setOpenUnit(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClickUnit);
    return () => {
      document.removeEventListener("click", handleOutsideClickUnit);
    };
  }, [anchorEl2]);

  const isCheckboxTagUnitDisabled = (tagUnit) => {
    return smartTagSelectTagUnit
      ? smartTagSelectTagUnit.length >= 1 &&
          !smartTagSelectTagUnit.some((device) => device.tagUnit === tagUnit)
      : false;
  };

  // Get color for a tag based on its selection order (for reports and analytics mode)
  const getTagColor = (tagId, index) => {
    if (activeSPCClass === "reports") {
      const selectionIndex = snartTagSelectTag.findIndex(
        (tag) => tag.tagId == tagId
      );
      if (selectionIndex !== -1) {
        return reportSwitchColors[selectionIndex];
      }
      // For unselected tags, return a default color based on index
      return switchColors[index % switchColors.length];
    }
    if (activeSPCClass === "analytics") {
      // Analytics mode: only one tag allowed, always use Steel Blue
      const isSelected = snartTagSelectTag.some((tag) => tag.tagId == tagId);
      if (isSelected) {
        return reportSwitchColors[0]; // Steel Blue
      }
      // For unselected tags, return a default color based on index
      return switchColors[index % switchColors.length];
    }
    // For other modes, use original index-based color
    return switchColors[index % switchColors.length];
  };

  // Check if tag switch should be disabled (SPC-specific selection limits)
  const isTagSwitchDisabled = (tagId) => {
    // Only apply selection limit logic for analytics and reports
    if (activeSPCClass == "analytics") {
      if (!snartTagSelectTag || snartTagSelectTag.length === 0) {
        return false;
      }
      // Filter tags by current plant ID
      const currentPlantTags = snartTagSelectTag.filter(
        (tag) => tag.plantId == param.plantid
      );
      // Analytics: only one tag allowed per plant
      if (currentPlantTags.length > 0) {
        const isCurrentlySelected = currentPlantTags.some(
          (tag) => tag.tagId == tagId
        );
        // Disable if not currently selected and there's already a selection
        return !isCurrentlySelected;
      }
    } else if (activeSPCClass == "reports") {
      if (!snartTagSelectTag || snartTagSelectTag.length === 0) {
        return false;
      }
      // Filter tags by current plant ID
      const currentPlantTags = snartTagSelectTag.filter(
        (tag) => tag.plantId == param.plantid
      );
      // Reports: allow up to 2 tags per plant
      // Only disable if we have exactly 2 tags selected AND this tag is not one of them
      if (currentPlantTags.length >= 2) {
        const isCurrentlySelected = currentPlantTags.some(
          (tag) => tag.tagId == tagId
        );
        // Disable if not currently selected and already have 2 selections for this plant
        return !isCurrentlySelected;
      }
    }
    return false;
  };

  const handleExportSPCReportsExcel = async () => {
    // Validate that tags are selected
    if (!snartTagSelectTag || snartTagSelectTag.length === 0) {
      notifyError("Please select at least one tag");
      return;
    }

    // Validate that start date and end date are available
    if (!formatStartDate || !formatEndDate) {
      notifyError("Please select start date and end date");
      return;
    }

    const params = {
      company: param.companyid,
      plant: param.plantid,
      tag: snartTagSelectTag.map((e) => e.tagId),
      interval: interval,
    };

    if (activeSPCClass == "reports") {
      // Get chart base64 image for Reports based on selected chart type
      let base64Image = "";
      if (getChartBase64) {
        try {
          base64Image = await getChartBase64();
        } catch (error) {
          notifyError(error.message || "Failed to capture chart image");
          return;
        }
      } else {
        notifyError("Chart is not available for export");
        return;
      }
      // Pass only the relevant key based on selected chart type
      if (selectedChartType === "I Chart") {
        params["base64_image_ichart"] = base64Image;
      } else if (selectedChartType === "MR Chart") {
        params["base64_image_mrchart"] = base64Image;
      }
    } else if (activeSPCClass == "analytics") {
      // Get both chart base64 images for Analytics
      if (getAnalyticsChartsBase64) {
        try {
          const chartsBase64 = await getAnalyticsChartsBase64();
          params["base64_image_ichart"] = chartsBase64.base64_image_ichart;
          params["base64_image_mrchart"] = chartsBase64.base64_image_mrchart;
        } catch (error) {
          notifyError(error.message || "Failed to capture chart images");
          return;
        }
      } else {
        notifyError("Charts are not available for export");
        return;
      }
    }

    if (time) {
      params["start_date"] = `${formatStartDate} ${formatStartTime}`;
      params["end_date"] = `${formatEndDate} ${formatEndTime}`;
    } else {
      params["start_date"] = `${formatStartDate} 00:00:00`;
      params["end_date"] = `${formatEndDate} 23:59:59`;
    }
    // console.log("params", params);
    try {
      let resp;
      if (activeSPCClass == "analytics") {
        resp = await exportSPCAnalyticsExcel(params);
      } else {
        resp = await exportSPCReportsExcel(params);
      }
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
      }
    } catch (error) {
      notifyError(error.response.data.message);
    }
  };

  const handleExportAnalyticsPOPExcel = async () => {
    const params = {
      company: param.companyid,
      plant: param.plantid,
      tag: snartTagSelectTag.map((e) => e.tagId),
      interval: interval,
    };
    if (disableOtherUnits) {
      params["aggregate"] = agg;
    } else {
      params["spike_range"] = range;
    }
    if (time) {
      params["start_date"] = `${formatStartDate} ${formatStartTime}`;
      params["end_date"] = `${formatEndDate} ${formatEndTime}`;
      params["start_date_1"] = `${formatStartDatePOP1} ${formatStartTimePOP1}`;
      params["end_date_1"] = `${formatEndDatePOP1} ${formatEndTimePOP1}`;
    } else {
      params["start_date"] = `${formatStartDate} 00:00:00`;
      params["end_date"] = `${formatEndDate} 23:59:59`;
      params["start_date_1"] = `${formatStartDatePOP1} 00:00:00`;
      params["end_date_1"] = `${formatEndDatePOP1} 23:59:59`;
    }
    try {
      const resp = await exportSmartTagAnalyticsPOP(params);
      if (resp.data.success == true) {
        notifySuccess(resp.data.message);
      }
    } catch (error) {
      notifyError(error.response.data.message);
    }
  };
  return (
    <>
      <Grid item xs={12} sm={12} md={3} lg={3}>
        <Box
          className={disableOtherUnits ? "smarTag-grid-box" : "smartTag-boxes"}
        >
          <Box className="consumer-text-disc">
            <div className="d-flex justify-content-between">
              <div>
                <h6 className="Title">Title</h6>
                <h6>Data Charts</h6>
              </div>
              <div>
                <Switch
                  checked={SmartTagSelectSwitch}
                  onChange={handleToggleTime}
                />
              </div>
            </div>
          </Box>

          <Box>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                padding: "13px 8px",
                borderRadius: "4px",
                width: "100%",
                background: "#f5f5f5",
                cursor: "pointer",
                marginTop: "4px",
              }}
              onClick={handleClick}
            >
              Select Device <ArrowDropDownIcon />
            </div>
          </Box>

          <Popper
            open={openMachine}
            anchorEl={anchorEl}
            placement="bottom-start"
            style={{ width: "23%", maxHeight: "300px", overflow: "auto" }}
            className="machine-dropdown"
          >
            <Paper>
              {!isShimmerMachineslist ? (
                machines?.length ? (
                  machines.map((row) => (
                    <MenuItem
                      className="vms-coc-menuItem"
                      onClick={handlePropagation}
                    >
                      {" "}
                      {row.device__device_name}{" "}
                      <Switch
                        style={{ float: "right" }}
                        checked={
                          smartTagSelectmachine.find(
                            (item) => item.machineId === row.device
                          )
                            ? true
                            : false
                        }
                        onClick={() => handleSelectMachine(row)}
                      />
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem
                    className="vms-coc-menuItem"
                    onClick={handlePropagation}
                  >
                    No Machine Found
                  </MenuItem>
                )
              ) : (
                <DeviceListShimmer itemCount={2} />
              )}
            </Paper>
          </Popper>
          {activeClassConsumer == "Consumer" ? (
            <Box>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "13px 8px",
                  borderRadius: "4px",
                  width: "100%",
                  background: "#f5f5f5",
                  cursor: "pointer",
                  marginTop: "4px",
                }}
                onClick={handleClickUnit}
              >
                Select Unit <ArrowDropDownIcon />
              </div>

              <Popper
                open={openUnit}
                anchorEl={anchorEl2}
                placement="bottom-start"
                style={{ width: "23%", maxHeight: "300px", overflow: "auto" }}
              >
                <Paper>
                  {!isShimmerUnitlist ? (
                    units?.length ? (
                      units.map((row) => (
                        <MenuItem
                          key={row.tag_unit}
                          className="vms-coc-menuItem"
                          onClick={handlePropagation}
                        >
                          {" "}
                          {row.tag_unit}{" "}
                          <Switch
                            style={{ float: "right" }}
                            checked={
                              smartTagSelectTagUnit.find(
                                (item) =>
                                  item.tagUnit.toLowerCase() ===
                                  row.tag_unit.toLowerCase()
                              )
                                ? true
                                : false
                            }
                            disabled={
                              (disableOtherUnits &&
                                !smartTagSelectTagUnit.find(
                                  (item) =>
                                    item.tagUnit.toLowerCase() ===
                                    row.tag_unit.toLowerCase()
                                )) ||
                              (!["kvah", "kvarh", "kwh", "agg"].includes(
                                row.tag_unit.toLowerCase()
                              ) &&
                                disableOtherUnits)
                            }
                            onClick={() => handleSelectTagUnit(row)}
                          />
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem
                        className="vms-coc-menuItem"
                        onClick={handlePropagation}
                      >
                        No Units Found
                      </MenuItem>
                    )
                  ) : (
                    <DeviceListShimmer itemCount={2} />
                  )}
                </Paper>
              </Popper>
            </Box>
          ) : (
            <Box>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "13px 8px",
                  borderRadius: "4px",
                  width: "100%",
                  background: "#f5f5f5",
                  cursor: "pointer",
                  marginTop: "4px",
                }}
                onClick={handleClickUnit}
              >
                Select Unit <ArrowDropDownIcon />
              </div>

              <Popper
                open={openUnit}
                anchorEl={anchorEl2}
                placement="bottom-start"
                style={{
                  width: "23%",
                  maxHeight: "300px",
                  overflow: "auto",
                  zIndex: 999,
                }}
              >
                <Paper>
                  {!isShimmerUnitlist ? (
                    units?.length ? (
                      units.map((row) => (
                        <MenuItem
                          key={row.tag_unit}
                          className="vms-coc-menuItem"
                          onClick={handlePropagation}
                        >
                          {" "}
                          {row.tag_unit}{" "}
                          <Switch
                            style={{ float: "right" }}
                            checked={
                              smartTagSelectTagUnit
                                ? smartTagSelectTagUnit.find(
                                    (f) => f.tagUnit == row.tag_unit
                                  )
                                  ? true
                                  : false
                                : false
                            }
                            disabled={
                              disableOtherUnits &&
                              !["kvah", "kvarh", "kwh", "agg"].includes(
                                row.tag_unit.toLowerCase()
                              ) &&
                              !smartTagSelectTagUnit.find(
                                (item) =>
                                  item.tagUnit.toLowerCase() ===
                                  row.tag_unit.toLowerCase()
                              )
                            }
                            onClick={() => handleSelectTagUnit(row)}
                          />
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem
                        className="vms-coc-menuItem"
                        onClick={handlePropagation}
                      >
                        No Units Found
                      </MenuItem>
                    )
                  ) : (
                    <DeviceListShimmer itemCount={3} />
                  )}
                </Paper>
              </Popper>
            </Box>
          )}

          <div style={{ marginTop: "14px", fontWeight: "bold" }}>Tag List</div>

          <TextField
            variant="outlined"
            className="search-textfield Smarttag-search"
            placeholder="Search Unit here"
            value={searchTag}
            onChange={(e) => setSearchTag(e.target.value)}
            InputProps={{
              startAdornment: <SearchIcon />,
              inputProps: {
                style: { padding: "9px" },
              },
            }}
          />

          <div
            className={
              disableOtherUnits
                ? "smarTag-Unit-grid"
                : "smartTag-report-taglist-unit"
            }
          >
            <Box className="Grid-text1 mt-2">
              {!isShimmerdevicelist ? (
                tagListData
                  ?.filter(
                    (e) =>
                      e.tag_name &&
                      e.tag_name.toLowerCase().includes(searchTag.toLowerCase())
                  )
                  .map((row, index) => (
                    <Grid item xs={12}>
                      <Grid
                        container
                        alignItems="center"
                        style={{
                          background: "#efeffd",
                          width: "100%",
                          marginBottom: "7px",
                        }}
                      >
                        <Grid
                          item
                          xs={8}
                          className="mt-2"
                          style={{
                            padding: "7px 12px",
                            borderLeft: `4px solid ${getTagColor(row.id, index)}`,
                          }}
                        >
                          <h6>{row.tag_name}</h6>
                        </Grid>
                        <Grid
                          item
                          xs={4}
                          textAlign="right"
                          className="grid-switch-unit"
                        >
                          <Switch
                            checked={
                              snartTagSelectTag.find((f) => f.tagId == row.id)
                                ? true
                                : false
                            }
                            disabled={isTagSwitchDisabled(row.id)}
                            style={{ float: "right" }}
                            name={getTagColor(row.id, index)}
                            onChange={(e) => {
                              e.stopPropagation();
                              let switchColor;
                              if (activeSPCClass === "reports") {
                                switchColor = reportSwitchColors[snartTagSelectTag.length];
                              } else if (activeSPCClass === "analytics") {
                                switchColor = reportSwitchColors[0]; // Steel Blue for analytics
                              } else {
                                switchColor = switchColors[index % switchColors.length];
                              }
                              handleSelectTag(row, switchColor);
                            }}
                            sx={{
                              "& .MuiSwitch-thumb": {
                                bgcolor: "#828282",
                              },
                              "& .MuiSwitch-track": {
                                bgcolor: "#D9D9E5 !important",
                              },
                              "& .Mui-checked": {
                                "& .MuiSwitch-thumb": {
                                  bgcolor: getTagColor(row.id, index),
                                },
                                "& .MuiSwitch-track": {
                                  bgcolor: "#CEE6E1 !important",
                                },
                              },
                              "& .Mui-disabled": {
                                "& .MuiSwitch-thumb": {
                                  bgcolor: "#d3d3d3",
                                },
                                "& .MuiSwitch-track": {
                                  bgcolor: "#f0f0f0 !important",
                                },
                              },
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  ))
              ) : (
                <DeviceListShimmer itemCount={7} />
              )}
            </Box>
          </div>

          {activeClassConsumer == "Consumer" ? (
            <div>
              <button
                className="export-btn"
                style={{ marginTop: "46px" }}
                onClick={handleExportSPCReportsExcel}
              >
                Export SmartTag Data
              </button>
            </div>
          ) : (
            <div>
              <button
                className="export-btn"
                style={{ marginTop: "46px" }}
                onClick={handleExportAnalyticsPOPExcel}
              >
                Export SmartTag Data
              </button>
            </div>
          )}
        </Box>
      </Grid>
    </>
  );
};
export default SPCSmartTagList;